import { BASE_URL_APP as baseUrl } from './baseUrl'
import { HTTP as http } from './axios'

export const HTTP = http

export const BASE_URL_APP = baseUrl

export const PATH_SEM_IMAGE = process.env.NODE_ENV === 'production'
? '/assets/images/sem_imagem.png'
: '/modamulher/assets/images/sem_imagem.png'
